import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {IconBox} from '../../../../libs/shared/ui/src/components/iconBox/iconBox';
import {fontSizes} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Style.
 */

const StyledBannerTextWrapperDiv = styled.div`
  font-size: ${fontSizes.verySmall};
  line-height: 16px;
`;

/*
 * Component.
 */

export const ContactCardDeniedBanner: FC = () => {
  const theme = useUserTheme();

  return (
    <IconBox
      iconName="notificationSmall"
      backgroundColor={theme.palette.orange.shade20}
      iconColor={theme.palette.orange.shade40}
    >
      <StyledBannerTextWrapperDiv>
        <Trans id="contact-card-banner-denied">
          You do not have permission to see this contact&apos;s details
        </Trans>
      </StyledBannerTextWrapperDiv>
    </IconBox>
  );
};
